var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs34(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215.26665,
    height: 500,
    viewBox: "0 0 56.955962 132.29165",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1.2429599e-4,-164.70837)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1F1\\uE201  \\uE1F1\\uE202   \\uE1F1\\uE203",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4452",
    transform: "matrix(10.656437,0,0,10.656497,-222.74223,-2175.8406)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uF5EA",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4574",
    transform: "matrix(15.644377,0,0,15.644377,-159.94201,-3194.5322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 12.022787,214.73571 c -0.04233,0 -0.08467,-0.0106 -0.127,-0.0106 -0.719667,0 -1.449917,0.47625 -1.449917,0.93133 0,0.27517 0.15875,0.64559 0.687917,0.68792 h 0.04233 c 0.370417,0 0.550334,-0.27517 0.550334,-0.55033 v -0.0741 c -0.02117,-0.30691 -0.232834,-0.32808 -0.275167,-0.34925 -0.04233,-0.0106 -0.169333,0 -0.169333,-0.11641 v -0.0317 c 0.02117,-0.14817 0.275166,-0.21167 0.359833,-0.21167 0.719667,0 0.783167,0.4445 0.783167,0.65617 v 0.0529 c 0,0.62442 -0.497417,0.87842 -1.037167,0.89959 -0.08467,0.0106 -0.201083,0.0529 -0.201083,0.14816 0,0.0952 0.148166,0.0952 0.211666,0.0952 0.973667,0 1.04775,0.66675 1.04775,0.77259 0,0.89958 -0.455083,0.99483 -0.635,0.99483 -0.04233,0 -0.07408,0 -0.08467,0 -0.0635,-0.0106 -0.22225,-0.0106 -0.232834,-0.13758 v -0.0423 c 0,-0.1905 0.1905,-0.3175 0.1905,-0.56091 0,-0.0847 0,-0.17992 -0.04233,-0.26459 -0.08467,-0.21166 -0.338667,-0.34925 -0.560917,-0.34925 -0.03175,0 -0.0635,0 -0.09525,0.0106 -0.148166,0.0317 -0.306916,0.11641 -0.402166,0.22225 -0.148167,0.127 -0.1905,0.32808 -0.1905,0.51858 0.02117,0.65617 0.613833,0.91017 1.449916,0.93133 h 0.07408 c 0.836083,0 1.703916,-0.43391 1.703916,-1.17475 v -0.0635 c -0.01058,-0.11641 -0.03175,-0.23283 -0.07408,-0.34925 -0.04233,-0.0847 -0.09525,-0.16933 -0.169333,-0.24341 -0.04233,-0.0635 -0.116417,-0.127 -0.201084,-0.17992 l -0.179916,-0.0952 -0.275167,-0.0847 c -0.04233,0 -0.0635,0 -0.08467,-0.0423 -0.01058,-0.0106 -0.01058,-0.0212 -0.01058,-0.0423 0,-0.0318 0.01058,-0.0635 0.03175,-0.0741 0.09525,-0.0212 0.1905,-0.0317 0.264583,-0.0741 0.127,-0.0635 0.243417,-0.11642 0.328084,-0.23283 0.137583,-0.14817 0.1905,-0.33867 0.1905,-0.53975 0,-0.77259 -1.058334,-1.00542 -1.418167,-1.02659 z m 1.100667,6.95325 v -1.80975 c 0,-0.0635 -0.01058,-0.14816 -0.105834,-0.14816 -0.07408,0 -0.116416,0.0212 -0.169333,0.0847 l -0.804333,0.97367 c -0.03175,0.0423 -0.07408,0.0847 -0.07408,0.1905 v 0.70908 h -1.143 c 0.677334,-0.5715 2.032,-2.49766 2.053167,-2.59291 0,-0.0106 0.01058,-0.0212 0.01058,-0.0423 0,-0.0635 -0.0635,-0.11641 -0.127,-0.11641 -0.07408,0 -0.423333,0.0212 -0.5715,0.0212 -0.15875,0 -0.53975,-0.0212 -0.60325,-0.0212 -0.07408,0 -0.201083,0.0318 -0.201083,0.15875 0,1.05833 -0.8255,2.23308 -1.0795,2.58233 l -0.05292,0.0741 c 0,0.0106 -0.01058,0.0106 -0.01058,0.0212 -0.01058,0.0318 -0.02117,0.0741 -0.02117,0.0952 0,0.0847 0.0635,0.14817 0.169334,0.14817 h 1.576916 v 0.52916 c 0,0.23284 -0.1905,0.29634 -0.338666,0.29634 -0.137584,0 -0.201084,0.0741 -0.201084,0.15875 0,0.0847 0.04233,0.17991 0.169334,0.17991 h 1.799166 c 0.08467,0 0.169334,-0.0635 0.169334,-0.17991 0,-0.11642 -0.105834,-0.16934 -0.1905,-0.16934 -0.08467,0 -0.254,-0.0529 -0.254,-0.3175 v -0.49741 h 0.613833 c 0.08467,0 0.127,-0.0635 0.127,-0.16934 0,-0.0952 -0.03175,-0.15875 -0.127,-0.15875 z",
    style: {
      strokeWidth: 2.38434362
    },
    id: "path4576"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs34);
export default __webpack_public_path__ + "static/media/ts-3-4.725bbeabfa14a50b3ff20b3fa279d42b.svg";
export { ForwardRef as ReactComponent };